import React from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'

import { Entity } from '../app/entity'
import Navigator from '../app/navigator'
import Link from '../helper/link'

import BoxBody from '../helper/boxBody'
import Loading from '../helper/loading'
import ExternalOperation from './external-operation'
import SortableColumnHeader from './operation/sortable-column-header'
import { ApplicationState } from '../redux/ApplicationState'

interface StateProps {
    navigator: Navigator
    parameters: { [key: string]: string }
    loading: boolean
    data: any
}

type Props = StateProps

class ExternalOperations extends React.Component<Props> {
    public static defaultProps = {
        loading: false,
        data: null,
    }

    public render() {
        const count = this.props.parameters.count || 20
        const sort = this.props.parameters.sort || 'average'

        if (!this.props.data) {
            return <Loading {...this.props} height={100} title="External HTTP Calls" />
        }

        return (
            <div className="box">
                <div className="box-header">
                    <nav className="navbar navbar-toolbar">
                        <div className="container-fluid">
                            <h3 className="box-title">Response Times By Host</h3>

                            <form
                                className="navbar-form navbar-right"
                                onSubmit={event => {
                                    event.preventDefault()
                                    event.stopPropagation()

                                    this.props.navigator.replace({ search: jQuery('.external-operation-list-search').val() })
                                }}
                            >
                                <div className="form-group has-feedback operation-list-group">
                                    <input
                                        className="form-control external-operation-list-search"
                                        defaultValue={this.props.parameters.search}
                                        type="text"
                                    />
                                    <i className="form-control-feedback fa fa-search" />
                                </div>
                            </form>
                        </div>
                    </nav>
                </div>

                <BoxBody {...this.props} className="no-padding">
                    <table className="table table-striped profile">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th style={{ width: 100 }} className="align-right">
                                    <SortableColumnHeader label={'Requests'} sortKey={'requests'} currentSortKey={sort} />
                                </th>
                                <th style={{ width: 160 }} className="align-right">
                                    <SortableColumnHeader label={'Average Response'} sortKey={'average'} currentSortKey={sort} />
                                </th>
                                <th style={{ width: 160 }} className="align-right">
                                    <SortableColumnHeader label={'Slowest Response'} sortKey={'max'} currentSortKey={sort} />
                                </th>
                                <th style={{ width: 110 }} className="align-right">
                                    <SortableColumnHeader label={'Failures'} sortKey={'errors'} currentSortKey={sort} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.data.critical.operations ? (
                                _.map(this.props.data.critical.operations, operation => {
                                    return <ExternalOperation full key={operation.id} operation={operation} />
                                })
                            ) : (
                                <tr>
                                    <td colSpan={5} align="center">
                                        No requests recorded in selected period.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        {count > this.props.data.critical.operations.length ? null : (
                            <tfoot>
                                <tr>
                                    <td colSpan={7} className="text-center">
                                        <Link
                                            route="XhprofOrganizationBundle.Application.show"
                                            params={{ count: (+this.props.parameters.count || 20) + 20 }}
                                        >
                                            Fetch more…
                                        </Link>
                                    </td>
                                </tr>
                            </tfoot>
                        )}
                    </table>
                </BoxBody>
            </div>
        )
    }
}

export default connect<StateProps & Entity<any>, {}, {}>((globalState: ApplicationState) => {
    const externalOperations = globalState.monitor.operations || new Entity()

    return {
        navigator: new Navigator(globalState.tidewaysContext.route),
        tidewaysContext: globalState.tidewaysContext,
        parameters: globalState.tidewaysContext.route.parameters,
        ...externalOperations,
    }
})(ExternalOperations)
